export var appConfigs = {
    "dtTagCnf": [
        {
            "instance": "casan",
            "tag": "E03DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E02DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E01DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E04DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E07DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E05DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E06DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E14DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E12DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E13DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E09DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E10DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E03DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E02DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E01DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E04DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E07DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E05DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E06DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E14DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E12DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E13DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E09DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E10DataHora",
            "layout": 1
        },
        {
            "instance": "casan",
            "tag": "E00DataHora",
            "layout": 1
        },
        {
            "instance": "vicunha",
            "tag": "CaptDataHora",
            "layout": 1
        },
        {
            "instance": "siop",
            "tag": "DataHora",
            "layout": 1
        },
        {
            "instance": "projetofundao",
            "tag": "Capt1DataHora",
            "layout": 1
        },
        {
            "instance": "projetofundao",
            "tag": "Capt2DataHora",
            "layout": 1
        },
        {
            "instance": "covolan",
            "tag": "CaptDataHora",
            "layout": 1
        },
        {
            "instance": "covolan",
            "tag": "ETADataHora",
            "layout": 1
        },
        {
            "instance": "cordeiropolis",
            "tag": "UR01DataHora",
            "layout": 1
        },
        {
            "instance": "cordeiropolis",
            "tag": "UR02DataHora",
            "layout": 1
        },
        {
            "instance": "cordeiropolis",
            "tag": "UR03DataHora",
            "layout": 1
        },
        {
            "instance": "cordeiropolis",
            "tag": "UR04DataHora",
            "layout": 1
        },
        {
            "instance": "cordeiropolis",
            "tag": "UR05DataHora",
            "layout": 1
        },
        {
            "instance": "cordeiropolis",
            "tag": "UR06DataHora",
            "layout": 1
        },
        {
            "instance": "cordeiropolis",
            "tag": "UR07DataHora",
            "layout": 1
        },
        {
            "instance": "cordeiropolis",
            "tag": "UR08DataHora",
            "layout": 1
        },
        {
            "instance": "cordeiropolis",
            "tag": "UR09DataHora",
            "layout": 1
        },
        {
            "instance": "cordeiropolis",
            "tag": "UR10DataHora",
            "layout": 1
        },

        {
            "instance": "ambev",
            "tag": "EtaDataHora",
            "layout": 1
        },
        {
            "instance": "ambev",
            "tag": "EteDataHora",
            "layout": 1
        },
        {
            "instance": "iot",
            "tag": "NAO_TEM",
            "layout": 1
        },
        {
            "instance": "daev",
            "tag": "NAO_TEM",
            "layout": 1
        }
    ]
};